


import React, { useEffect, useState } from 'react';
import { MdDownloadForOffline } from 'react-icons/md';

const InstallButton = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [isVisible, setIsVisible] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [isInstalled, setIsInstalled] = useState(false);

  useEffect(() => {
    console.log('Checking PWA installation status...');
    
    const handleBeforeInstallPrompt = (e) => {
      console.log('BeforeInstallPrompt event triggered');
      e.preventDefault();
      setDeferredPrompt(e);
      setIsVisible(true);
      
      // Check if the app is already installed
      const isAppInstalled = localStorage.getItem('appInstalled') === 'true' || 
                            window.matchMedia('(display-mode: standalone)').matches;
      
      console.log('Is app already installed?', isAppInstalled);
      setIsVisible(!isAppInstalled);
    };

    const handleAppInstalled = () => {
      console.log('App installed event triggered');
      setIsVisible(false);
      setIsInstalled(true);
      localStorage.setItem('appInstalled', 'true');
    };

    // Check if the browser supports PWA installation
    const isPwaSupported = () => {
      return window.matchMedia('(display-mode: standalone)').matches ||
             window.navigator.standalone ||
             (window.matchMedia('(display-mode: browser)').matches && 
              'BeforeInstallPromptEvent' in window);
    };

    if (isPwaSupported()) {
      window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
      window.addEventListener('appinstalled', handleAppInstalled);
    }

    // Check on initial load if app is already installed
    if (window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone) {
      console.log('App is running in standalone mode');
      setIsInstalled(true);
      localStorage.setItem('appInstalled', 'true');
    }

    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
      window.removeEventListener('appinstalled', handleAppInstalled);
    };
  }, []);

  const handleInstallClick = async () => {
    console.log('Install button clicked');
    if (!deferredPrompt) {
      console.warn('No deferred prompt available');
      // Fallback for browsers that don't support beforeinstallprompt
      window.open('https://your-app-url.com/manifest.json', '_blank');
      return;
    }
    
    try {
      console.log('Prompting installation...');
      deferredPrompt.prompt();
      const { outcome } = await deferredPrompt.userChoice;
      
      console.log('User choice:', outcome);
      if (outcome === 'accepted') {
        console.log('User accepted the install prompt');
        setIsVisible(false);
        localStorage.setItem('appInstalled', 'true');
      } else {
        console.log('User dismissed the install prompt');
      }
      
      setDeferredPrompt(null);
    } catch (err) {
      console.error('Error handling install prompt:', err);
    }
  };

  if (isInstalled || !isVisible) {
    console.log('App is already installed or prompt not available, hiding button');
    return null;
  }

  return (
  

    <div className="z-50">
      <div className="relative group">
        <button
          onClick={handleInstallClick}
          className="p-2 bg-black bg-opacity-70 text-white rounded-full shadow-lg backdrop-blur-sm 
                    transition-all duration-200 hover:bg-opacity-90 hover:scale-110 
                    focus:outline-none focus:ring-2 focus:ring-white focus:ring-opacity-50"
          aria-label="Install app"
        >
          <MdDownloadForOffline size={16} />
        </button>
        
        {/* Tooltip with guaranteed visibility */}
        <div className="absolute top-full right-0 mt-2 transition-all duration-200
                       opacity-0 group-hover:opacity-100 translate-y-1 group-hover:translate-y-0
                       pointer-events-none group-hover:pointer-events-auto">
          <div className="bg-gray-800 text-white text-xs py-1 px-2 rounded whitespace-nowrap shadow-lg">
            Install App
            <div className="absolute -top-1 right-2 w-0 h-0 border-l-2 border-r-2 border-b-2 border-l-transparent border-r-transparent border-b-gray-800"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InstallButton;

